import { useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useStatusContext } from "../../context/StatusContextProvider/StatusContextProvider";

import classes from "./AuthSelection.module.css";

import { BaseURL } from "../../user/home/BaseData";

const AuthSelection = () => {
  const { t } = useTranslation();
  const [inputText, setInputText] = useState({
    name: "",
    surename: "",
    phone: "",
    email: "",
    userMessage: "",
  });
  const { onSuccessStatus } = useStatusContext();

  // Handle input change
  const handlInputChanger = (e) => {
    const { name, value } = e.target;
    setInputText({ ...inputText, [name]: value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      // Send data to backend API
      await axios.post(`${BaseURL}/api/contact/`, {
        name: inputText.name,
        surename: inputText.surename,
        phone: inputText.phone,
        email: inputText.email,
        userMessage: inputText.userMessage,
      });

      // Clear form after successful submission
      setInputText({
        name: "",
        surename: "",
        phone: "",
        email: "",
        userMessage: "",
      });

      // Show success message
      onSuccessStatus({
        title: t("Murojaatingiz muvaffaqiyatli yuborildi!!!"),
        message: t(" "),
      });
    } catch (error) {
      console.error("Error sending message:", error);
      console.error("Error details:", error.response?.data);
      
      // Show error message to user
      onSuccessStatus({
        title: t("Xatolik yuz berdi"),
        message: t("Iltimos, keyinroq qayta urinib ko'ring"),
      });
    }
  };

  return (
    <div className={classes["message_form"]}>
      <div data-aos="fade-right" className={classes["left_side"]}>
        <h3 className={classes["form_title"]}>
          {t("Rektor virtual qabulxonasi")}
        </h3>
        <form onSubmit={handleSubmit}>
          <input
            placeholder={t("nameOfPlaceholder")}
            className={classes["form_input"]}
            type="text"
            name="name"
            value={inputText.name}
            onChange={handlInputChanger}
            required
          />
          <input
            placeholder={t("surnameOfPlaceholder")}
            className={classes["form_input"]}
            type="text"
            name="surename"
            value={inputText.surename}
            onChange={handlInputChanger}
            required
          />
          <input
            placeholder={t("numberOfPlaceholder")}
            className={classes["form_input"]}
            type="text"
            name="phone"
            value={inputText.phone}
            onChange={handlInputChanger}
            required
          />
          <input
            placeholder={t("emailOfPlaceholder")}
            className={classes["form_input"]}
            type="text"
            name="email"
            value={inputText.email}
            onChange={handlInputChanger}
            required
          />
          <textarea
            placeholder={t("messageOfPlaceholder")}
            className={classes["form_input"]}
            name="userMessage"
            value={inputText.userMessage}
            cols="30"
            rows="10"
            onChange={handlInputChanger}
            required
          ></textarea>
          <button type="submit" className={classes["form_btn"]}>
            {t("Murojaat yuborish")}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AuthSelection;
